var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
function SvgUserLock16(_a, svgRef) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "YdsSvgIcon-root ".concat(className !== null && className !== void 0 ? className : ''), width: '1rem', height: '1rem', fill: "currentColor", focusable: "false", "aria-hidden": "true", ref: svgRef }, props),
        React.createElement("g", { id: "user_lock_16_svg__user_lock_16" },
            React.createElement("g", { id: "user_lock_16_svg__user_lock_16-2", "data-name": "user_lock_16" },
                React.createElement("path", { id: "user_lock_16_svg__Pfad_4378", "data-name": "Pfad 4378", d: "M0 0h16v16H0Z", fill: "none" }),
                React.createElement("path", { id: "user_lock_16_svg__Vereinigungsmenge_180", "data-name": "Vereinigungsmenge 180", d: "M-2902-2112.812v-4h.5v-.5a2.5 2.5 0 0 1 2.5-2.5 2.5 2.5 0 0 1 2.5 2.5v.5h.5v4Zm1.5-4.5v.5h3v-.5a1.5 1.5 0 0 0-1.5-1.5 1.5 1.5 0 0 0-1.5 1.5Zm-2.5 2.5h-9a7.075 7.075 0 0 1 .486-2.006c.132-.121 3.448-1.416 4.867-1.967l-.057-.469a5.239 5.239 0 0 1-2.037-4.233 3.213 3.213 0 0 1 3.262-3.513h.058a3.236 3.236 0 0 1 2.359 1.027 3.226 3.226 0 0 1 .845 2.484 5.231 5.231 0 0 1-2.036 4.233l-.046.382.142.064c.278.126.931.419 1.657.751v.247h-.5v3Z", transform: "translate(2912 2127.813)" })))));
}
var ForwardRef = React.forwardRef(SvgUserLock16);
export default ForwardRef;
